// @flow
import React, { PureComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import theme from '../../../theme-config';
import DeliveryStatusBar from './DeliveryStatusBar';

export default class Timeline extends PureComponent<Props> {
  styles = getStyles();

  render() {
    const styles = this.styles;
    const status = this.props.status;
    const statusKeys = Object.keys(this.props.statusMapping);
    const statusNames = Object.values(this.props.statusMapping);
    return (
      <View>
        <View style={styles.container}>
          <DeliveryStatusBar
            backgroundColor={status === statusKeys[0] ? theme.gray.light : theme.primaryColor}
            side={'left'}
          >
            <View style={[styles.circle, { backgroundColor: theme.primaryColor }]} />
          </DeliveryStatusBar>
          <DeliveryStatusBar
            backgroundColor={status === statusKeys[2] ? theme.primaryColor : theme.gray.light}
            side={'right'}
          >
            <View
              style={[
                styles.circle,
                {
                  left: -10,
                  backgroundColor: status === statusKeys[0] ? theme.gray.light : theme.primaryColor,
                },
              ]}
            />
            <View
              style={[
                styles.circle,
                {
                  backgroundColor: status === statusKeys[2] ? theme.primaryColor : theme.gray.light,
                },
              ]}
            />
          </DeliveryStatusBar>
        </View>
        <View style={styles.legendContainer}>
          <Text style={[styles.legend, { color: theme.gray.normal }]}>{statusNames[0]}</Text>
          <Text
            style={[
              styles.legend,
              {
                right: 10,
                color: status === statusKeys[0] ? theme.gray.light : theme.gray.normal,
              },
            ]}
          >
            {statusNames[1]}
          </Text>
          <Text
            style={[
              styles.legend,
              {
                color: status === statusKeys[2] ? theme.gray.normal : theme.gray.light,
              },
            ]}
          >
            {statusNames[2]}
          </Text>
        </View>
      </View>
    );
  }
}

type Props = {
  status: string,
  statusMapping: Object,
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: 16,
    },
    circle: {
      borderRadius: 50,
      height: 20,
      width: 20,
    },
    legendContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginVertical: 10,
    },
    legend: {
      fontSize: 13,
    },
  });
